import { get } from "../api/client";
import { onApiError } from "../error";
import { type Currency, t } from "../locale";

interface Prices {
	FarmcamSimExtraData: Price;
	FarmcamSimSmall: Price;
	FarmcamSimMedium: Price;
	FarmcamSimLarge: Price;
	FencealarmMonth: Price;
	FencealarmYear: Price;
	Fencealarm2Month: Price;
	Fencealarm2Year: Price;
	SmartplugMonth: Price;
	SmartplugYear: Price;
	Smartplug2Month: Price;
	Smartplug2Year: Price;
	Sms: Price;
}

export interface Price {
	Id: string;
	Name: string;
	Eur: number;
	Sek: number;
}

export class PriceWrapper {
	toString(): string {
		if (!this.id) {
			return `0 ${this.currency}`;
		}

		switch (this.name) {
			case "FarmCam SIM Extra Data":
				return `${this.amount} ${this.currency}`;
			case "FarmCam SIM Small (100 MB)":
			case "FarmCam SIM Medium (250 MB)":
			case "FarmCam SIM Large (2 GB)":
			case "FenceAlarm+ Month":
			case "SmartPlug Control+ Month":
			case "SmartPlug2 Month":
				return t.price.monthly(this.amount, this.currency);
			case "FenceAlarm+ Year":
			case "SmartPlug Control+ Year":
			case "SmartPlug2 Year":
				return t.price.yearly(this.amount, this.currency);
			case "SMS":
				return `${this.amount} ${this.currency}`;
			default:
				throw `no price with name: ${this.name}`;
		}
	}

	amount;
	currency: Currency;
	id;
	name;

	constructor(country: string, price?: Price) {
		if (price) {
			this.amount = country === "SE" ? price.Sek : price.Eur;
		} else {
			this.amount = 0;
		}
		this.currency = country === "SE" ? "SEK" : "EUR";
		this.id = price ? price.Id : "";
		this.name = price ? price.Name : t.none;
	}
}

export const prices = (async (): Promise<Prices> => {
	const res = await get("/prices", {
		timeout: 20000,
	});
	if (!res.ok) throw await onApiError(res);
	return await res.json();
})();
